module.exports = __webpack_public_path__ + "img/life-insurance-hands.4be461a.webp";